export default "__VITE_ASSET__k6CJQV2u__"